import { render, staticRenderFns } from "./DevolucionesTableListComponent.vue?vue&type=template&id=19305ac3&"
import script from "./DevolucionesTableListComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionesTableListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports